import React from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import {
  AufbauFilter,
  AusstattungFilter,
  FarbeAussenFilter,
  FinanceFilter,
  FzartFilter,
  GetriebeFilter,
  ErstzulassungFilter,
  KilometerFilter,
  KraftstoffFilter,
  MarkeModellGruppeFilter,
  LocationFilter,
  MarkeFilter,
  ModellFilter,
  LeistungFilter,
  TuerenFilter,
  SitzeFilter,
} from "./components/filters";

import Indicator from "../Indicator";

import { FilterStatus } from "./Status";

interface ISchnellsuche {}
const Schnellsuche: React.FC<ISchnellsuche> = () => {
  const [showAll, setShowAll] = React.useState<boolean>(false);
  return (
    <>
      <Box
        sx={{
          width: "100%",
          m: 1,
          pt: 1,
          display: "grid",
          columnGap: { xs: 1, sm: 1, md: 2, lg: 3 },
          rowGap: { xs: 2, lg: 3 },
          gridTemplateColumns: {
            sm: "repeat(4, 1fr)",
            xs: "repeat(2, 1fr)",
          },
        }}
      >
        <FilterStatus sx={{ gridColumn: { xs: "span 2", sm: "span 4" } }} />
        <Box sx={{ gridColumn: { xs: "span 2", sm: "span 4" } }}>
          <Indicator />
        </Box>
        <FinanceFilter variant="simple" />
        <MarkeFilter variant="simple" />
        <ModellFilter variant="simple" />
        <KilometerFilter variant="simple" />
        <ErstzulassungFilter variant="simple" />
        <LocationFilter variant="simple" />
        <FzartFilter variant="simple" />
      </Box>
      <Button
        sx={{
          display: "flex",
          width: "100%",
          mb: 1,
        }}
        onClick={() => setShowAll(true)}
      >
        <span>weitere Filter</span>
      </Button>
      <Dialog
        id="carbando-page-catalog-sidefilter-root"
        open={showAll}
        fullScreen
        onClose={() => setShowAll(false)}
        scroll="paper"
      >
        <FilterStatus sx={{ p: 1 }} />
        <Box sx={{ gridColumn: { xs: "span 2", sm: "span 4" }, px: 1, mb: 1 }}>
          <Indicator />
        </Box>
        <DialogContent dividers sx={{ p: 0 }}>
          <MarkeModellGruppeFilter />
          <KilometerFilter />
          <ErstzulassungFilter />
          <FinanceFilter />
          <LocationFilter />
          <FzartFilter />
          <KraftstoffFilter />
          <LeistungFilter />
          <AufbauFilter />
          <AusstattungFilter />
          <GetriebeFilter />
          <FarbeAussenFilter />
          {process.env.REACT_APP_VEHICLE_TYPE !== "krad" && <TuerenFilter />}
          {process.env.REACT_APP_VEHICLE_TYPE !== "krad" && <SitzeFilter />}
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              display: showAll ? "flex" : "none",
              width: "100%",
              my: 2,
            }}
            onClick={() => setShowAll(false)}
          >
            weniger Filter
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default Schnellsuche;
